import { render } from "./updatePassword.vue?vue&type=template&id=742f9ad4"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__